
import { React, useEffect, useState, useRef } from 'react'
import { motion } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import PortalComponents from '../../components/PortalComponents/PortalComponents';
import { Button, Checkbox,Chip } from "@nextui-org/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft,faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import '../CustomerPortal.css';
import DropFileInput from '../../components/DragAndDrop/components/drop-file-input/DropFileInput';
import ContactChange from './ContactChange';
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter,useDisclosure} from "@nextui-org/react";
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const PolicyDetailsView = ({ formik, selectedData ,req_count,UserDetailAlt,policy_number}) => {
    const toast = useRef(null);
    const [contactNumber ,setContactNumber]= useState(formik.values.policy_mobile.oldMobile)
    const {isOpen, onOpen, onClose} = useDisclosure();
    const [verified, setVerified] = useState(false);
    const [countdown, Setcountdown] = useState(0);
    const [proofDocError, setProofDocError] = useState(null);

    const oldPaymentDetails = [...(selectedData.payment_history_details || [])]
        .sort((a, b) => new Date(b.mdate) - new Date(a.mdate));

    const riderCovers  = selectedData.rider_covers;

    const fullAddress = [
        formik.values?.policy_address1,
        formik.values?.policy_address2,
        formik.values?.policy_address3,
        formik.values?.policy_address4
    ].filter(line => !!line).join(', ');


    //Payment details table mdate formatter
    const formatDate = (dateString) => {
        // Handle special case of "0000-00-00" or other known invalid formats
        if (dateString === '0000-00-00' || !dateString) {
            return 'Date not specified!';
        }
    
        const date = new Date(dateString);
        
        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return 'Date not specified!';
        }
        
        return date.toISOString().split('T')[0];
    };
     //Payment details table mdate formatter

    function onClickRequest(){
        const currentVals = formik.values;
        const oldVals = selectedData;
        
        formik.validateForm().then(async (errors) => {      

            if (Object.keys(errors).length === 0&&proofDocError==null ) {


                if(currentVals?.policy_fullname !=oldVals?.policy_fullname ){
                    UserDetailAlt("policy_fullname")
        
                }
                if( currentVals?.policy_nic != oldVals?.policy_nic  ){
                    UserDetailAlt("policy_nic")
        
                }
                if( currentVals?.policy_address1!=oldVals?.policy_address1||currentVals?.policy_address2!=oldVals?.policy_address2 ||  currentVals?.policy_address3!=oldVals?.policy_address3||currentVals?.policy_address4!=oldVals?.policy_address4 ){
                    UserDetailAlt("policy_address")
        
                }
                if(currentVals?.policy_mobile.oldMobile!=contactNumber){
                    UserDetailAlt("policy_mobile")
                }
            }
        else{
            toast.current.clear();
            toast.current.show({
              severity: 'error',
              summary: 'Invalid or missing Information',
    
              life: 3000,
              sticky: false,
              content: (props) => (
                <div className="p-3" style={{ flex: '1' }}>
                  <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                  <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                </div>
              ),
            });
        }
        }
            
            
            
            )
      
    }

  
    function CheckProofErrors() {
        // Get current and old values
        const currentVals = formik.values;
        const oldVals = selectedData;
      
       
        if (
           ( currentVals?.policy_fullname !=oldVals?.policy_fullname ||
            currentVals?.policy_nic != oldVals?.policy_nic   ||
            currentVals?.policy_address1!=oldVals?.policy_address1||
            currentVals?.policy_address2!=oldVals?.policy_address2||
            currentVals?.policy_address3!=oldVals?.policy_address3||
            currentVals?.policy_address4!=oldVals?.policy_address4 ) &&
            currentVals.policy_proofdoc.length==0

        ) {
           
            
            setProofDocError( "*Required");
        } else {
 
           
            setProofDocError(null)
        }
    }
    

const fieldBoxStyle = {
  backgroundColor: '#f4faff',
  border: '1px solid #c0deef',
  borderRadius: '8px',
  padding: '10px',
  minHeight: '60px',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
};   
    useEffect(() => {
        CheckProofErrors();
    }, [formik.values, selectedData]); 
    
    return (
        <div style={{padding:10}}>
              <Toast ref={toast} position="top-center" />
            <Modal
                size='4xl'
                isOpen={isOpen}
                onClose={onClose}
            >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">Change Contact Info</ModalHeader>
                            <ModalBody>
                                <ContactChange
                                    formik={formik}

                                    UserDetailAlt={UserDetailAlt}
                                    policy_number={policy_number}
                                    verified={verified}
                                    setVerified={setVerified}
                                    countdown={countdown}
                                    Setcountdown={Setcountdown}


                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" variant="light" onPress={onClose}>
                                    Close
                                </Button>
                                <Button color="primary" onPress={()=>{
                                    setContactNumber(formik.values.policy_mobile.newMobile)
                                    onClose();

                                }}
                                isDisabled={!verified}
                                >

                                    Submit
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>

<Row className="policy-form-row" style={{ margin: 0 }}>
  <div style={{ backgroundColor: '#ffaa65ff', padding: '10px', marginBottom: '20px', borderRadius: '10px', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' }}>
  <h1 className="section-title" style={{ fontSize: "20px", fontWeight: "bold", textAlign: "center", marginBottom: "10px", marginTop: "10px", color: "#003366" }}>
    POLICY DETAILS
  </h1>
</div>
  {/* Full Name and NIC */}
<Col xs={12} md={6} className="policy-form-col">
  <label className="field-label">Full Name</label>
  <div className="field-box">{formik.values.policy_fullname}</div>
</Col>

<Col xs={12} md={6} className="policy-form-col">
  <label className="field-label">NIC</label>
  <div className="field-box">{formik.values.policy_nic}</div>
</Col>

{/* Full Address and Plan */}
<Col xs={12} md={6} className="policy-form-col">
  <label className="policy-label">Address</label>
  <div className="field-box">
    {[formik.values?.policy_address1, formik.values?.policy_address2, formik.values?.policy_address3, formik.values?.policy_address4]
      .filter(line => !!line)
      .join(', ')}
  </div>
</Col>

<Col xs={12} md={6} className="policy-form-col">
  <label className="policy-label">Plan</label>
  <div className="field-box">{selectedData.PLAN_NAME}</div>
</Col>

{/* Term and Sum Assured */}
<Col xs={12} md={6} className="policy-form-col">
  <label className="policy-label">Term</label>
  <div className="field-box">{selectedData.TERM}</div>
</Col>

<Col xs={12} md={6} className="policy-form-col">
  <label className="policy-label">Sum Assured</label>
  <div className="field-box">{selectedData.SUMASSURED}</div>
</Col>

{/* Contact Number and Commencement Number */}
<Col xs={12} md={6} className="policy-form-col">
  <label className="policy-label">Contact Number</label>
  <div className="field-box">{selectedData.policy_mobile}</div>
</Col>

<Col xs={12} md={6} className="policy-form-col">
  <label className="policy-label">Commencement Date</label>
  <div className="field-box">
  {selectedData.COM_DATE
    ? `${selectedData.COM_DATE.slice(0, 4)}-${selectedData.COM_DATE.slice(4, 6)}-${selectedData.COM_DATE.slice(6, 8)}`
    : ''}
</div>
</Col>

{/* Policy Status and Beneficiaries */}
<Col xs={12} md={6} className="policy-form-col">
  <label className="policy-label">Policy Status</label>
  <div className="field-box">{selectedData.status}</div>
</Col>

<Col xs={12} md={6} className="policy-form-col">
  <label className="policy-label">Beneficiaries</label>
  <div className="field-box">
    {Array.isArray(selectedData.beneficiaries)
      ? selectedData.beneficiaries.join(', ')
      : selectedData.beneficiaries}
  </div>
</Col>


</Row>
<br /><br />

<div style={{ backgroundColor: '#ffaa65ff', padding: '10px', borderRadius: '10px', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' }}>
  <h1 style={{ fontSize: "20px", fontWeight: "bold", textAlign: "center", marginBottom: "10px", marginTop: "10px", color: "#003366" }}>
    RIDER COVERS
  </h1>
</div>
<br />
<DataTable
  value={riderCovers}
  className="custom-rider-table"
  paginator
  rows={10}
  filterDisplay="row"
  globalFilterFields={['coveR_NAME']}
  stripedRows
  style={{ padding: "15px", backgroundColor: "#F9FAFB" }}
>
  <Column field="coveR_NAME" header="COVER" />
  <Column field="ridercoveR_SUMASSURED" header="SUM ASSURED" />
  <Column field="ridercoveR_PREMIUM" header="PREMIUM" />
</DataTable>

<br />           
{/* HERE */}
<div style={{ backgroundColor: '#ffaa65ff', padding: '10px', borderRadius: '10px', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' }}>
  <h1 style={{ fontSize: "20px", fontWeight: "bold", textAlign: "center", marginBottom: "10px", marginTop: "10px", color: "#003366" }}>
    PAYMENT HISTORY
  </h1>
</div>
<DataTable
  xs={12}
  md={6}
  value={oldPaymentDetails}
  dataKey="id"
  paginator
  rows={10}
  filterDisplay="row"
  globalFilterFields={['mdate', 'premium', 'receipt_no', 'dues']}
  className="p2-datatable"
  stripedRows
  style={{ padding: "15px", backgroundColor: "#F9FAFB" }}
>
  <Column
    style={{ padding: "10px" }}
    field="mdate"
    header="DATE"
    filter
    filterPlaceholder="Date"
    body={(rowData) => formatDate(rowData.mdate)}
  />
  <Column field="premium" header="PREMIUM PAYMENT" />
  <Column field="receipt_no" header="RECEIPT" />
  <Column field="dues" header="DUE" />
</DataTable> 
{/* TO HERE */}

        </div>

    )
}
